module.exports = __webpack_public_path__ + "media/app/assets/classes/druid-55cacca45e68698cbf81d31fab8741cf.jpg";